import * as yup from "yup";
import { ThermostatSettingSchema } from "./ThermostatSettingSchema";
export var ThermostatSettingsSchema;
(function (ThermostatSettingsSchema) {
    ThermostatSettingsSchema.Schema = yup.object().shape({
        id: yup.string().required(),
        settings: yup.array().of(ThermostatSettingSchema.Schema),
    });
})(ThermostatSettingsSchema || (ThermostatSettingsSchema = {}));
//# sourceMappingURL=ThermostatSettingsSchema.js.map